import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import CardContent from '@mui/material/CardContent';
import { labActions } from '../../core/actions';
import { importPackageData } from '../../data/labPackageDataStore';
import Abdominal from '../radiology/Abdominal';
import DopplerStudy from '../radiology/DopplerStudy';
import Follicular from '../radiology/Follicular';
import Scrotum from '../radiology/Scrotum';
import Obstetric from '../radiology/Obstetric';
import LowerLimbVenousSystem from '../radiology/LowerLimbVenousSystem';
import LowerLimbArterialSystem from '../radiology/LowerLimbArterialSystem';
import RadiologyOther from '../radiology/RadiologyOther';

function RadiologyTemplate(props) {
    console.log(props, "RadiologyTemplate props");
    console.log("Template ID received in RadiologyTemplate:", props.templateId);

    const dispatch = useDispatch();
    const [templateId, setTemplateId] = useState('');
    const [flag, setFlag] = useState(false);
    const [pData, setPData] = useState([]);
    const [comflag, setComflag] = useState();
    const [comid, setComid] = useState();
    // const [isNewTemplate, setIsNewTemplate] = useState(false);

    // Update the useEffect to handle both flows:
    useEffect(() => {
        console.log("RadiologyTemplate props:", props);
        
        if (props.mode === 'editComposition') {
            // Existing edit flow
            setComid(props.templateId);
            setComflag(props.mode);
        } else {
            // New flow from dropdown
            const patientId = props.fileUploadcontent?.patientId || props.patientData[0]?.patientId;
            const visitId = props.fileUploadcontent?.visitId || props.patientData[0]?.visitId;

            let patientDetails = [{ patientId, visitId }];
            setPData(patientDetails);
            setTemplateId(props.templateId);
            setFlag(true);
            
            // Check if this is a new template (no longdesc) or editing existing
            // setIsNewTemplate(!props.selectedProcedure?.longdesc);
        }
    }, [props]);

    const closeModal = (event) => {
        if (event?.success) {
            props.onModalClose(event);
        } else {
            props.onModalClose();
        }
    }

    const renderTemplateComponent = () => {
        // if (comflag === 'editComposition') {
        //     return (
        //         <Follicular
        //             {...props}
        //             templateData={comid}
        //             patientData={pData}
        //             selectedProcedure={props.selectedProcedure}
        //             flags={comflag}
        //             patientInfo={props.patientInfo}
        //             mode="edit"
        //             closeModal={closeModal}
        //         />
        //     );
        // }

        if (!flag) return null;

        // Determine mode based on whether it's a new template or editing existing
        // const templateMode = isNewTemplate ? "new" : "edit";
        
        switch (templateId) {
            case 'FOLLICULAR STUDY CYCLE':
                return (
                    <Follicular
                      templateData={templateId}
                        patientData={pData}
                        patientInfo={props.patientInfo}
                        selectedProcedure={props.selectedProcedure}
                        mode="new"
                        closeModal={closeModal} />
                );
            case 'OBSTETRIC ULTRA SONOGRAPHY':
                return (
                    <Obstetric
                        templateData={templateId}
                        patientData={pData}
                        patientInfo={props.patientInfo}
                        selectedProcedure={props.selectedProcedure}
                        mode="new"
                        closeModal={closeModal}
                    />
                );
            case 'LOWER LIMB VENOUS SYSTEM':
                return (
                    <LowerLimbVenousSystem
                        templateData={templateId}
                        patientData={pData}
                        patientInfo={props.patientInfo}
                        selectedProcedure={props.selectedProcedure}
                        mode="new"
                        closeModal={closeModal}
                    />
                );
            case 'LOWER LIMB ARTERIAL SYSTEM':
                return (
                    <LowerLimbArterialSystem
                        templateData={templateId}
                        patientData={pData}
                        patientInfo={props.patientInfo}
                        selectedProcedure={props.selectedProcedure}
                        mode="new"
                        closeModal={closeModal}
                    />
                );
            case 'SCROTUM':
                return (
                    <Scrotum
                         templateData={templateId}
                        patientData={pData}
                        patientInfo={props.patientInfo}
                        selectedProcedure={props.selectedProcedure}
                        mode="new"
                        closeModal={closeModal}
                    />
                );
            case 'ABDOMINAL/PELVIS SONOGRAPHY':
                return (
                    <Abdominal
                       templateData={templateId}
                        patientData={pData}
                        patientInfo={props.patientInfo}
                        selectedProcedure={props.selectedProcedure}
                        mode="new"
                        closeModal={closeModal}
                    />
                );
            case 'DOPPLER  STUDY':
                return (
                    <DopplerStudy
                        templateData={templateId}
                        patientData={pData}
                        patientInfo={props.patientInfo}
                        selectedProcedure={props.selectedProcedure}
                        mode="new"
                        closeModal={closeModal}
                    />
                );
            case 'RADIOLOGY OTHER':
                return (
                    <RadiologyOther
                        templateData={templateId}
                        patientData={pData}
                        patientInfo={props.patientInfo}
                        selectedProcedure={props.selectedProcedure}
                        mode="new"
                        closeModal={closeModal}
                    />
                );
            default:
                return <div>No matching radiology template found.</div>;
        }
    };

    const closeFormSchema = (event) => {
        setFlag(false);
        props.onRadiologyTemplateModalClose(event);
    }

    return (
        <div className="bg-none nav-wrapper h-100 d-flex flex-column template-view">
            <div className="d-flex">
                <IconButton
                    aria-label="close"
                    onClick={closeModal}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </div>

            <div className="d-flex" >
                <CardContent className="w-100">
                    <div className="template-container">
                        {renderTemplateComponent()}
                    </div>
                </CardContent>
            </div>
        </div>
    );
}

export default RadiologyTemplate;